import {kSystemIcons} from "../../../constants/icons";

export default function GamesTimerBadge() {
    // Used in

    // BUILD
    return (
        <div className={"bg-greenStar/30 flex justify-center items-center rounded-[12px] w-[48px] min-w-[48px] h-[48px] min-h-[48px]"}>
            <i className="material-icons text-[32px] text-greenStar">
                {kSystemIcons.timer}
            </i>
        </div>
    );
}